// src/data/team.js

// Import team member photos


export const teamMembers = [
  {
    id: 1,
    name: 'Yadnesh Sontakke',
    photo: "https://lh3.googleusercontent.com/d/1s7wnql2-2CHc8B_k07JgEDCRInZseweg",
    department: 'Founder & CEO',
    email: 'yadnesh.s24-26@iiebm.com',
    socials: {
      linkedin: 'https://www.linkedin.com/in/yadnesh-sontakke-3ab78b337/',
      twitter: '#',
    },
  },
  {
    id: 2,
    name: 'Lokesh Saini',
    photo: "https://lh3.googleusercontent.com/d/1mFrcFf_7hePSIQeNaI9Ywyy9GFs9DA1l",
    department: 'CFO',
    email: 'lokesh.s24-26@iiebm.com',
    socials: {
      linkedin: 'https://www.linkedin.com/in/lokeshksaini/',
      twitter: '#',
    },
  },
  {
    id: 3,
    name: 'Rushikesh Khore',
    photo: "https://i.ibb.co/QvK6T4wz/Rushikesh-Kore-CTO.png",
    department: 'CTO',
    email: 'rushikesh.k24-26@iiebm.com',
    socials: {
      linkedin: 'https://www.linkedin.com/in/rushikesh-kore-3374a8225/',
      github: '#',
    },
  },
  {
    id: 4,
    name: 'Pushkaraj khandelwal',
    photo: "https://i.ibb.co/TD9qz6Rq/pushkaraj-khandelwal-CMO.png",
    department: 'CMO',
    email: 'pushkraj.k24-26@iiebm.com',
    socials: {
      linkedin: 'https://www.linkedin.com/in/pushkraj-khandelwal-6032a824a/',
      dribbble: '#',
    },
  },
  {
    id: 5,
    name: 'Rohit Kumar',
    photo: "https://i.ibb.co/KzcFRby9/Rohit-Kumar.png",
    department: 'Member',
    email: 'rohit.k24-26@iiebm.com',
    socials: {
      linkedin: 'https://www.linkedin.com/in/rohit-k04152000/',
    },
  },
  {
    id: 6,
    name: 'Venkatesh Tammireddy',
    photo: "https://i.ibb.co/RkbxwNbN/Venkatesh-Tammireddy.png",
    department: 'Member',
    email: 'venkatesh.t24-26@iiebm.com',
    socials: {
      linkedin: 'https://www.linkedin.com/in/venkatesh-tammireddy-2bb23b287/',
    },
  },
  // Add more team members here
];